// extracted by mini-css-extract-plugin
module.exports = {"root":"B_b9","filled":"B_cp","input-area":"B_cq","inputArea":"B_cq","label":"B_cr"};